"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initPanoramaClient = exports.globalConfig = void 0;
const panorama_client_web_1 = require("@wix/panorama-client-web");
exports.globalConfig = (0, panorama_client_web_1.createGlobalConfig)();
const initPanoramaClient = ({ fullArtifactId, componentId }) => {
    const panoramaClient = (0, panorama_client_web_1.panoramaClientFactory)({
        baseParams: {
            platform: panorama_client_web_1.PanoramaPlatform.Standalone,
            fullArtifactId,
            componentId,
        },
    })
        .withGlobalConfig(exports.globalConfig)
        .client();
    panoramaClient.reportLoadStart();
    return panoramaClient;
};
exports.initPanoramaClient = initPanoramaClient;
//# sourceMappingURL=panoramaClient.js.map